export enum DemoConstants {
  UPDATE_AIRWAY = 'demo/UPDATE_AIRWAY',
}
